module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showExport && !_vm.getIsExportingAgents) ? _c('div', {
    staticClass: "dark font-weight-600 d-flex"
  }, [_c('span', {
    staticClass: "pointer mr-3 relative",
    on: {
      "click": function($event) {
        _vm.showingExportOptions = !_vm.showingExportOptions
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-export fs-large"
  }), _vm._v(" "), _c('span', [_vm._v("Export")]), _vm._v(" "), (_vm.showingExportOptions) ? _c('ul', {
    staticClass: "floating-menu bottom centered"
  }, _vm._l((_vm.exportOptions), function(exportOption) {
    return _c('li', {
      key: exportOption.label
    }, [_c('span', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleExport(exportOption.action)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(exportOption.label) + "\n                ")])])
  }), 0) : _vm._e()])]) : _c('div', {
    staticClass: "mr-3"
  }, [_c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a30f12"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/ExportV2.vue
// module id = 2398
// module chunks = 0